import { Injectable } from '@angular/core';

@Injectable()
export class ScheduleValidationService {

  constructor() { }

  public validateForm(values: { scheduledStartTime: Date; scheduledEndTime: Date; }): ValidationData {
    const minDate = new Date();

    let validationErrors = [];

    if (!!values.scheduledStartTime !== !!values.scheduledEndTime) {
      validationErrors.push({ message: 'Start and End time must both be added or neither added.' });
    }

    if (values.scheduledStartTime && values.scheduledEndTime) {
      if (values.scheduledStartTime.getTime() > values.scheduledEndTime.getTime()) {
        validationErrors.push({ message: 'Start time must be before the End time.' });
      }

      if (values.scheduledStartTime.getTime() < minDate.getTime()) {
        validationErrors.push({ message: 'Start time must be in the future.' });
      }

      if (values.scheduledEndTime.getTime() < minDate.getTime()) {
        validationErrors.push({ message: 'End time must be in the future.' });
      }
    }

    if (!validationErrors.length) {
      return {
        isValid: true
      }
    } else {
      return {
        isValid: false,
        validationErrors: validationErrors,
      }
    }
  }
}

export interface ValidationData {
  isValid: boolean,
  validationErrors?: any[];
}
